import gql from 'graphql-tag'

export const VehicleWithRelationsFragment = gql`
  fragment VehicleWithRelations on Vehicle {
    id
    slug
    stage

    title

    customerBenefits {
      id
      slug
      stage

      title

      topics {
        id
      }
    }

    topics {
      id
      slug
      stage

      title

      customerBenefits {
        id
      }
      components {
        id
      }
    }

    components {
      id
      slug
      stage

      title

      topics {
        id
      }
      vehicles {
        id
      }
    }
  }
`

export default gql`
  query Vehicle($vehicleSlug: String!, $lang: [Locale!]!, $stage: Stage!) {
    vehicle(where: { slug: $vehicleSlug } locales: $lang stage: $stage) {
      ...VehicleWithRelations
    }
  }
  ${VehicleWithRelationsFragment}
`



// WEBPACK FOOTER //
// ./src/queries/vehicleWithRelations.js